<mat-card [ngClass]="ratingClasses[form.value.rating]">
   <form [formGroup]="form">
      <mat-card-title>
         <div class="name">
            <div class="breadcrumbs">
               <ng-container *ngIf="businessUnitName">
                  <div class="breadcrumb-text">
                     {{ businessUnitName }}
                  </div>
                  <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>
               </ng-container>
               <ng-container *ngIf="departmentName">
                  <div class="breadcrumb-text">
                     {{ departmentName }}
                  </div>
                  <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>
               </ng-container>
            </div>
            {{ viewModel.departmentFunction.name }}
            <div class="lead" *ngIf="viewModel.departmentFunction.leadId">
               <mat-icon>person</mat-icon>
               <div class="lead-name">
                  {{ viewModel.departmentFunction.leadId | teamMemberName: teamMembers }}
               </div>
            </div>
         </div>
         <button
            mat-icon-button
            *ngIf="canEdit"
            [disabled]="form.pristine"
            (click)="save()"
            class="save-button"
            color="primary"
         >
            <mat-icon>save</mat-icon>
         </button>
      </mat-card-title>
      <mat-card-content>
         <div class="left-col">
            <div class="text-editor">
               <app-text-editor
                  [config]="kpiEditorConfig"
                  label="KPI"
                  [formCtrl]="getFormControl('kpi')"
                  [canEdit]="canEdit"
                  [alwaysShowLabel]="true"
               ></app-text-editor>
            </div>
            <div class="text-editor">
               <app-text-editor
                  [config]="benchmarkEditorConfig"
                  label="Benchmark"
                  [formCtrl]="getFormControl('benchmark')"
                  [canEdit]="canEdit"
                  [alwaysShowLabel]="true"
               ></app-text-editor>
            </div>
         </div>
         <div class="right-col">
            <mat-form-field class="rating">
               <mat-label>Rating</mat-label>
               <mat-select
                  formControlName="rating"
                  name="rating"
                  [ngClass]="{ 'read-only': !canEdit }"
               >
                  <mat-option *ngFor="let r of ratingKeys" [value]="r">
                     {{ rating[r] }}
                  </mat-option>
               </mat-select>
            </mat-form-field>
            <div class="rating-notes">
               <app-text-editor
                  [config]="notesEditorConfig"
                  label="Rating notes"
                  [formCtrl]="getFormControl('ratingNotes')"
                  [canEdit]="canEdit"
                  [alwaysShowLabel]="true"
               ></app-text-editor>
            </div>
         </div>
      </mat-card-content>
   </form>
</mat-card>
